

import axiosInstance from "../lib/axios";

export const getSubCategoryByCategory = (id: number) => {
  return axiosInstance.get(`/SubCategory/List/${id}`);
};
